/* eslint-disable no-undef */
import './Hompage.scss';
import './HomepageMobile.scss';

import { ArrowForward} from '@mui/icons-material'; //VisibilityOff
import Button from '@mui/material/Button';
import React from 'react';
import {useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import {buttonStylesBlue, buttonStylesGreen,} from '../../Components/docsAdministrative/JsObjectStyles';
import FooterGlobal from '../../Components/shared/Footer/FooterGlobal';
import PrincipalNavbar from '../../Components/shared/Navbar/PrincipalNavbar';
import usePersistedLanguage from '../../hooks/usePersistedLanguage';
import useWindowSize from '../../hooks/useWindowSize';
// import videoConsulting from './4433139-uhd_3840_2160_25fps.mp4';
import videoConsulting from './4433139-Uhd-3840-2160-25Fps.webm';
// ! why React becomes Too slow ..? SVG takes too much
// Could not find a declaration file for module 'react-trello'. 'C:/Users/Reda El Ouahabi/Desktop/HTH/hth_frontend/node_modules/react-trello/dist/index.js' implicitly has an 'any' type.
//   Try `npm i --save-dev @types/react-trello` if it exists or add a new declaration (.d.ts) file containing `declare module 'react-trello';

function GlobalHome() {

    // ! multiLanguages
    const { t, i18n } = useTranslation();
    console.log(t, i18n);
    const navigate = useNavigate();
    usePersistedLanguage();

    const { device } = useWindowSize();

    return (
        <React.Fragment>
            <div
                className='App-intro'
                style={{background:'none',gap:'0px'}}
            >
                <PrincipalNavbar />
                {device=='desktop' &&
                <video
                    autoPlay
                    loop
                    muted
                    playsInline
                    className="background-video"
                >
                    <source
                        src={videoConsulting}
                        type="video/webm"
                    />
                    {/* <source src={videoConsulting} type="video/mp4" /> */}
                    Your browser does not support the video tag.
                </video>
                }
                <div className="video-overlay">
                    <div className="content-overlay">
                        <div
                            className="homeExpertf28"
                            style={{width:'80%'}}
                        >
                            <h5
                                className='homeExpertf16 homeExpertf31B'
                                style={{color:device=='desktop' ?'white':'rgb(32, 57, 179)',fontSize:'72px',lineHeight:'70px'}}
                            >
                                {i18n.t('Trouvez l\'expertise qu\'il vous faut pour réussir')}
                            </h5>
                            <h3
                                className='frame101HomePage'
                                style={{color:device=='desktop' ?'white':'rgb(32, 57, 179)',fontSize:'24px',lineHeight:'56px',letterSpacing:'1.25px',alignSelf:'center'}}
                            >
                                {i18n.t('Découvrir nos solutions')}
                            </h3>
                        </div>
                        <div
                            className="horizontal-line"
                            style={{marginTop:device=='desktop' ? '99px':'25px',borderTopColor:device=='desktop' ?'white':'rgb(32, 57, 179)'}}
                        ></div>
                        <div className="homeConsult32">
                            <Button
                                onClick={()=>{
                                    navigate('/Consulting');
                                }}
                                endIcon={<ArrowForward />}
                                className="my-button"
                                style={{...buttonStylesGreen(false),width:device=='desktop'?'auto':'100%',backgroundColor:'rgb(0, 94, 35)',fontSize:'17px','&:hover': {
                                    backgroundColor: 'rgb(32, 57, 179)',
                                },}}
                                // style={{...buttonStyles(false),width:device=='desktop'?'auto':'100%',color:device=='desktop' ?'white':'rgb(32, 57, 179)',fontSize:'17px',fontFamily:'sans-serif',fontWeight:'100',boxShadow:'rgba(0, 0, 0, 0.7) 0px 4px 15px',backgroundColor:'rgba(200, 200, 200, 0.15)' }}
                            >
                                {i18n.t('Consulting')}
                            </Button>
                            <Button
                                onClick={()=>{
                                    navigate('/Sourcing');
                                }}
                                className="my-button"
                                endIcon={<ArrowForward />}
                                // style={{...buttonStyles(false),width:device=='desktop'?'auto':'100%',color:device=='desktop' ?'white':'rgb(32, 57, 179)',fontSize:'17px',fontFamily:'sans-serif',fontWeight:'100',boxShadow:'rgba(0, 0, 0, 0.7) 0px 4px 15px',backgroundColor:'rgba(200, 200, 200, 0.15)' }}
                                style={{...buttonStylesBlue(false),width:device=='desktop'?'auto':'100%',fontSize:'17px'}}
                            >
                                {i18n.t('Sourcing')}
                            </Button>
                        </div>
                    </div>
                </div>
                <FooterGlobal
                    styleProps={{
                        background:'#2039B3',
                        marginTop:'0px',
                        zIndex:'1',
                    }}
                />
            </div>
        </React.Fragment>
    );
}

export default GlobalHome;